import { i18n } from '@/i18n/settings'
import { Config } from '@/Config'
import router from '@/router'

export function viteConfig(key, { defaultValue = undefined, parse = true } = {}) {
  const raw = import.meta.env['VITE_' + key];
  if (raw === undefined) return defaultValue;

  if (!parse) return raw;

  // try boolean
  if (raw === 'true') return true;
  if (raw === 'false') return false;

  // try number (safe)
  const num = Number(raw);
  if (!Number.isNaN(num) && raw.trim() !== '') return num;

  // try JSON
  try {
    return JSON.parse(raw);
  } catch (e) {
    // not JSON -> return original string
    return raw;
  }
}

export function isValidNumber(value) {
  if (value === '' || value == null) return true
  if (typeof value === 'number') return Number.isFinite(value)
  const s = String(value).trim()
  if (s === '') return true
  return !Number.isNaN(Number(s))
}